import { c as _c } from "react/compiler-runtime";
import './recent-activity-panel.scss';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
export const RecentActivityPanelSkeleton: React.FC = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="pl-comfy-lg pt-comfy-sm pb-comfy-sm flex flex-1 flex-col gap-snug-xl"><Skeleton height={28} width={255} /><Skeleton height={16} width={255} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton height={28} width={128} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><Skeleton height={16} width={152} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-snug-xl">{t1}<div className="flex items-center justify-between">{t2}<div className="hidden @xs:block"><Skeleton height={16} width={105} /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="RecentActivityPanel @container flex items-center p-snug-lg rounded-md w-full relative"><div className="RecentActivityPanel__content flex flex-1 flex-col">{t0}<div className="RecentActivityPanel__items flex flex-1 flex-col gap-snug-xl w-full"><div className="RecentActivityItem flex pt-comfy-sm p-comfy-lg rounded-md w-full h-[144px] relative"><div className="RecentActivityItem__content flex flex-1 flex-col gap-comfy-lg">{t3}<div className="flex flex-col gap-comfy-xs"><Skeleton height={16} width="100%" /></div></div></div></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};